import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getSignerListSelector } from '../selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { ISignerData } from '../store/completeChart.types'
import { saveSigner } from '../store/completeChart.actions'
import { CompleteChartConstants } from '../store/completeChart.constants'

export function* saveSignerData() {
  const signerDetails: ISignerData = yield select(getSignerListSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      signerDetails,
    }
    try {
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(saveSigner())
    } catch (e) {
      yield put(throwPcrException(`saveSignerData() error: ${e}`))
    }
  }
}
export function* saveSignerDataSaga() {
  yield takeLatest(
    [
      CompleteChartConstants.SET_USER,
      CompleteChartConstants.SET_SIGN_CHART_AS,
      CompleteChartConstants.SET_PIN,
      CompleteChartConstants.SET_ANSWER1,
      CompleteChartConstants.SET_ANSWER2,
      CompleteChartConstants.SET_VERIFY_CREW,
      CompleteChartConstants.SET_CLINICAL_USER,
      CompleteChartConstants.ADD_SIGNER,
      CompleteChartConstants.DELETE_SIGNER,
      CompleteChartConstants.SET_CLINICAL_USER_LIST,
      CompleteChartConstants.SET_CLINICAL_USER,
      CompleteChartConstants.SET_SECURITY_QUESTION_ANSWER_LIST,
      CompleteChartConstants.SET_COMPLEX_RULES_COUNT,
    ],
    performWithMutexHOG,
    saveSignerData
  )
}
